import React, {useState} from 'react';
import {useTranslation, withTranslation} from "react-i18next";
import PopupModal from "../../../Modal/PopupModal";
import CartChangeOrderDetailsTypesModal from "./CartChangeOrderDetailsTypesModal";
import {connect, DispatchProp} from "react-redux";
import {RootState} from "../../../../../reducers";
import {getStoreConfig} from "../../../../services/Store/reducer";
import {getSession} from "../../../../services/Session/reducer";
import {ConfigAddressApi, DineInType, OrderType, StoreConfigCoordinatesApi} from "../../../../services/Api/types";
import CartChangeOrderDetailsDeliveryAddressModal from "./Delivery/CartChangeOrderDetailsDeliveryAddressModal";
import CartChangeOrderDetailsTimeModal from "./CartChangeOrderDetailsTimeModal";
import CartChangeOrderDetailsRoomModal from "./RoomService/CartChangeOrderDetailsRoomModal";
import CartChangeOrderDetailsDineInOptionsModal from "./DineIn/CartChangeOrderDetailsDineInOptionsModal";
import IframeWidget from "../../../../utils/IframeWidget";
import {useSessionService} from "../../../../services/Session/sessionService";

interface OwnProps {
    show: boolean;
    onHide: () => void;
    onSave?: (session: Record<string, any>) => void;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps & DispatchProp;

const CartChangeOrderDetailsModal = ({show, onHide, config, session, onSave}: Props) => {
    const {t} = useTranslation();
    const [errors, setErrors] = useState<{ field: string; code: string; }[]>([]);
    const [address, setAddress] = useState<ConfigAddressApi>(session.address);
    const [currentType, setCurrentType] = useState<OrderType | "">(session.order_type ? session.order_type as OrderType : "");
    const [time, setTime] = useState<string | undefined>(session.pickup_at);
    const [room, setRoom] = useState<string | undefined>(session.room_number);
    const [dineInOption, setDineInOption] = useState<DineInType | undefined>(session.dine_in_type);
    const [table, setTable] = useState(session.table_number);
    const [loading, setLoading] = useState(false);
    const sessionService = useSessionService();
    const [coordinates, setCoordinates] = useState<StoreConfigCoordinatesApi | undefined>();
    const [forceStreet, setForceStreet] = useState(false);

    const isSaveButtonDisabled = () => {
        if(forceStreet && !address.street && currentType === OrderType.DELIVERY) return true;

        switch (currentType) {
            case OrderType.DINE_IN: {
                return !dineInOption;
            }
            default:
                return false;
        }
    }

    const handleSave = async () => {
        setLoading(true);

        try {
            const sessionValue = {
                ...session,
                room_number: room,
                order_type: currentType,
                dine_in_type: dineInOption,
                pickup_at: time,
                table_number: table,
                address,
                coordinates: coordinates ?? session.coordinates
            };
            await sessionService.update(sessionValue);
            if (onSave) onSave(sessionValue);
            IframeWidget.onHide(onHide);
        } catch (err) {
            return null;
        }
        setLoading(false);
    }

    return (
        <PopupModal
            className="change-order-details-modal"
            show={show}
            onHide={onHide}
            onShow={() => {
            }}
            scrollable
            title=""
            bodyContent={<>
                <CartChangeOrderDetailsTypesModal currentType={currentType} setCurrentType={setCurrentType}
                                                  time={time} setTime={setTime} setDineInOption={setDineInOption}/>
                <CartChangeOrderDetailsDeliveryAddressModal currentType={currentType} config={config} address={address}
                                                            setAddress={setAddress} errors={errors}
                                                            setErrors={setErrors} setCoordinates={setCoordinates}
                                                            setForceStreet={setForceStreet} forceStreet={forceStreet}
                />
                <CartChangeOrderDetailsRoomModal room={room} setRoom={setRoom} currentType={currentType}
                                                 config={config}/>
                <CartChangeOrderDetailsDineInOptionsModal config={config} current={dineInOption}
                                                          currentType={currentType} table={table}
                                                          setDineInOption={setDineInOption} setTable={setTable}/>
                <CartChangeOrderDetailsTimeModal time={time} onChange={setTime} currentType={currentType}/>
            </>}
            primaryButton={
                <button
                    disabled={isSaveButtonDisabled()}
                    className={`btn-spinner btn btn-primary mt-2 w-100 ${loading ? "loading" : ""}`}
                    onClick={handleSave}>
                    <span className="left spinner-border spinner-border-sm"/>
                    {t("common.action.save")}
                </button>
            }
        />
    )
}

const mapStateToProps = (state: RootState) => ({
    config: getStoreConfig(state.config),
    session: getSession(state.session),
})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(CartChangeOrderDetailsModal));